export enum AgreementType {
  NotDefined = 0,
  Framework = 1, // Rammeavtale
  Dynamic = 2, // Dynamisk innkjøpsordning (Free pricing)
}
